import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { SiteCustomizations } from "../../helpers/constants";
import siteCustomization from "../../helpers/siteCustomization";

import { IAppState } from "../../types/stores/index";
//import { useSaasHeader } from "@ascend/ui-core/hooks";
import { requestLogout } from "../../actions/sessionActions";

const SaasHeader: React.FC = () => {
    const SAAS_ASSETS_URL = "https://in-api.experian.com/decisionanalytics/experianone/saas-assets-ui";
    const enabledFeatures = useSelector((state: IAppState) => state.session.enabledFeatures || []);
    const wayfarerMode = enabledFeatures.includes("integrate-wayfarer-header");
    const siteCustomizations = useSelector((state: IAppState) => state.session.customizations);
    const title = siteCustomization(SiteCustomizations.AEname, "Audience Engine", siteCustomizations, true);
    const HEADER_ELEMENT_KEY = "saas-header";
    // const { initialiseSaasHeader, hasError } = useSaasHeader({
    //     title,
    //     selector: HEADER_ELEMENT_KEY,
    // });

    useEffect(() => {
        if (wayfarerMode) {
            // Insert the necessary scripts
            const script = document.createElement("script");
            script.setAttribute("type", "text/javascript");
            script.setAttribute("src", `${SAAS_ASSETS_URL}/common-components/experian-saas-header.js`);
            document.head.appendChild(script);

            // Load the webcomponents-bundle.js script
            const webComponentsScript = document.createElement("script");
            webComponentsScript.setAttribute("src", "/Scripts/js/webcomponents-bundle.js");
            document.head.appendChild(webComponentsScript);

            // Function to initialize SaasHeaderLite
            const initializeHeader = () => {
                const SaasHeaderLite = window.ExperianSaaSComponent.SaasHeaderLite; // Use optional chaining
                window.logoutFunction = function () {
                    if (top) {
                        top.store.dispatch(requestLogout());
                    }
                };
                if (SaasHeaderLite) {
                    // ***************************************************************************************************8
                    // ***** To add function, we need to add software-lib-ui-core
                    // https://pages.experian.local/display/AOP/Header+Usage
                    // https://code.experian.local/projects/DASA/repos/software-lib-ui-core/browse/src/utils/window.ts#91
                    //const navResourceCenter = () => dispatch(openTabToUrl("/wiki/"));

                    // addFunctionsToWindow({
                    //     navResourceCenter: navResourceCenter,
                    //     navDocumentation: navDocumentation,
                    //     selectCompany: selectCompany,
                    // });

                    //new SaasHeader({ title: title, selector: HEADER_ELEMENT_KEY, navContent: navContent, utilities: utilities });
                    /* eslint-disable no-new */
                    new SaasHeaderLite({ title, selector: HEADER_ELEMENT_KEY, logoutPreHook: "logoutFunction" });
                    /* eslint-enable no-new */

                    // handlePubSubHelp();
                    // ***************************************************************************************************8
                    // ***** Can we need to remove this? This is failing
                    // Call any initialization method if needed
                    // saasHeaderInstance.initialize();
                }
            };

            // Prepare the SaasHeader class to be called and subsequently initialize the header
            window.addEventListener("SaasHeaderLiteReady", initializeHeader);

            return () => {
                // Cleanup the appended elements when the component unmounts
                document.head.removeChild(script);
                document.head.removeChild(webComponentsScript);
                window.removeEventListener("SaasHeaderLiteReady", initializeHeader);
            };
        }
    }, [wayfarerMode, title]);

    return <>{wayfarerMode && <div id="saas-header"></div>}</>;
};

SaasHeader.propTypes = {};

export default SaasHeader;
